import { ColorNeutralGrey3, Spacing16, Spacing8 } from 'autogen/design-tokens/tokens';
import Card from 'components/generic/card';
import styled from 'styled-components';
import { type CheckoutGiftCardLine } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import { ShowGiftCard } from 'autogen/translation-keys/trans-website-checkout-giftcard';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import GiftCardLine from './GiftCardLine';
import AddGiftCardLineButton from './AddGiftCardLineButton';

const StyledCardContent = styled(Card.Content)`
    gap: ${Spacing16};
`;

const StyledCard = styled(Card)`
    border: 1px solid ${ColorNeutralGrey3};
`;

export default function GiftCardForm({ model: giftCardLines }: { model: CheckoutGiftCardLine[] }) {
    const { t } = useTranslation();
    return (
        <Flex.Column>
            <Typography.Title size="S">{t(ShowGiftCard)}</Typography.Title>
            <StyledCard size={{ xs: 'sm', sm: 'md' }}>
                <StyledCardContent>
                    {giftCardLines.map((giftCardLine, index) => (
                        <GiftCardLine key={giftCardLine.id} model={giftCardLine} index={index} />
                    ))}
                    <AddGiftCardLineButton />
                </StyledCardContent>
            </StyledCard>
        </Flex.Column>
    );
}
